const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg14CaseManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x30_3-case-manager"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M5.5,37.9V13.5c0-0.7,0.6-1.3,1.3-1.3h4.7c0.3,0,0.7,0.1,0.9,0.4l2.6,2.6c0.2,0.2,0.6,0.4,0.9,0.4h22.7c0.7,0,1.3,0.6,1.3,1.3v5.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#333333",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M14.5,22.1c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#333333",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M23.9,22.1c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#333333",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M33.1,22.1c0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.4892,
    y1: 31.3989,
    x2: 44.997,
    y2: 31.3989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M10.5,23L5.6,37.4c-0.4,1.7,0.8,3.3,2.5,3.3h28.7c1.2,0,2.2-0.8,2.5-1.9l5.6-15.1 c0.2-0.8-0.4-1.7-1.3-1.7h-32C11.1,22.1,10.6,22.5,10.5,23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#08A1DC",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M10.5,23L5.6,37.4c-0.4,1.7,0.8,3.3,2.5,3.3h28.7c1.2,0,2.2-0.8,2.5-1.9l5.6-15.1c0.2-0.8-0.4-1.7-1.3-1.7h-32 C11.1,22.1,10.6,22.5,10.5,23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.2909,
    y1: 13.8636,
    x2: 22.6823,
    y2: 13.8636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    cx: 20,
    cy: 13.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.6902,
    y1: 13.8636,
    x2: 32.0816,
    y2: 13.8636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    cx: 29.4,
    cy: 13.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.9111,
    y1: 13.8636,
    x2: 41.3024,
    y2: 13.8636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    cx: 38.6,
    cy: 13.9,
    r: 2.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14CaseManager);
export default __webpack_public_path__ + "static/media/14-case-manager.3454e7c093ed5d184555ca7c53e236a5.svg";
export { ForwardRef as ReactComponent };